
import React from 'react';
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { useKeycloakContext } from '@/contexts/KeycloakContext';
import { useUserRole } from '@/hooks/useUserRole';
import { User, Mail, Shield } from 'lucide-react';
import { Link } from 'react-router-dom';

const Profile = () => {
  const { user, signOut } = useKeycloakContext();
  const { role, isLoading } = useUserRole();

  if (isLoading) {
    return (
      <div className="flex justify-center items-center min-h-screen">
        <div className="animate-spin rounded-full h-10 w-10 border-b-2 border-primary"></div>
      </div>
    );
  }

  return (
    <div className="container max-w-4xl mx-auto py-8 px-4 sm:px-6">
      <h1 className="text-3xl font-bold mb-8">My Profile</h1>
      
      <Card className="mb-8">
        <CardHeader>
          <CardTitle className="flex items-center">
            <User className="mr-2" size={20} />
            User Information
          </CardTitle>
          <CardDescription>Your account details</CardDescription>
        </CardHeader>
        <CardContent className="space-y-4">
          <div className="flex items-center">
            <Mail className="mr-2 text-muted-foreground" size={16} />
            <span className="text-sm font-medium">Email:</span>
            <span className="ml-2">{user?.email}</span>
          </div>
          <div className="flex items-center">
            <Shield className="mr-2 text-muted-foreground" size={16} />
            <span className="text-sm font-medium">Role:</span>
            <span className="ml-2 capitalize">{role}</span>
          </div>
          {user?.picture && (
            <div className="mt-4">
              <img 
                src={user.picture} 
                alt="Profile" 
                className="w-20 h-20 rounded-full"
              />
            </div>
          )}
        </CardContent>
        <CardFooter className="flex justify-between flex-col sm:flex-row gap-2">
          <Button onClick={signOut} variant="destructive">Sign Out</Button>
          {role === 'admin' && (
            <Button asChild>
              <Link to="/admin">Go to Admin Dashboard</Link>
            </Button>
          )}
        </CardFooter>
      </Card>
    </div>
  );
};

export default Profile;
